import { motion, type HTMLMotionProps } from "motion/react";
import type { ReactNode } from "react";
import { cn } from "@/lib/cn";
import { fadeUp } from "@/lib/motion";

type DivProps = HTMLMotionProps<"div"> & { children?: ReactNode };

/** Solid content surface. */
export function Card({ className, children, ...rest }: DivProps) {
  return (
    <motion.div variants={fadeUp} className={cn("rounded-lg bg-surface p-4", className)} {...rest}>
      {children}
    </motion.div>
  );
}

/** Liquid-glass hero card. Use once per screen for the focal number. */
export function GlassCard({ className, children, ...rest }: DivProps) {
  return (
    <motion.div variants={fadeUp} className={cn("glass-hero rounded-xl p-5", className)} {...rest}>
      <div
        aria-hidden
        className="pointer-events-none absolute inset-x-0 top-0 h-1/2 bg-gradient-to-b from-white/25 to-transparent dark:from-white/5"
      />
      <div className="relative">{children}</div>
    </motion.div>
  );
}
